import styled from "styled-components";

export const OnGoingDocumentDisplayWrapper = styled.div`
  width: 70%;
  margin: auto;
  border-radius: 5px;
  border: ${({ theme }) => {
    return `1px solid ${theme.colors.green};`;
  }};
  padding: 20px;
  margin-top: 20px;
  margin-bottom: 20px;
`;

export const OngoingText = styled.div`
  text-align: ${({ align }) => {
    if (align === "left") return "left";
    if (align === "right") return "right";
    return "center;";
  }};
  font: normal normal 600 16px/22px Open Sans;
  letter-spacing: 0px;
  color: ${({ theme }) => {
    return theme.colors.darkgrey;
  }};
  margin: 5px auto;
`;
